import { btnPrimario, btnSecundario, chip, money } from '../../components/ui/estilos';
import { ESTADOS, ESTADO_ITEM, Estado, TIEMPOS, minutosDesde, duracion } from './mesas';

export interface Accion { label: string; primaria?: boolean; onClick: () => void }

export interface DetalleMesa {
  titulo: string;
  estado: Estado;
  zona: string;
  info: { k: string; v: string }[];
  nota: string;
  items: any[] | null;       // null = cargando
  total: number;
  pedirPersonas: boolean;
  acciones: Accion[];
  enlaces: Accion[];         // acciones poco frecuentes (separar, cambiar estado)
}

interface Props {
  pestana: 'mesa' | 'llevar';
  onPestana: (p: 'mesa' | 'llevar') => void;
  detalle: DetalleMesa | null;
  personas: number;
  onPersonas: (n: number) => void;
  llevar: any[];
  onNuevoLlevar: () => void;
  onLlevar: (p: any) => void;
}

const cuadro: React.CSSProperties = { ...btnSecundario, width: 60, height: 60, padding: 0, fontSize: 28, borderRadius: 12 };

export default function PanelMesa({ pestana, onPestana, detalle: d, personas, onPersonas, llevar, onNuevoLlevar, onLlevar }: Props) {
  const tabs: [typeof pestana, string][] = [['mesa', d?.titulo || 'Mesa'], ['llevar', `Para llevar · ${llevar.length}`]];
  const st = d ? ESTADOS[d.estado] : null;

  return (
    <aside style={{ background: 'var(--surface)', border: '1px solid var(--line)', borderRadius: 16, display: 'flex', flexDirection: 'column', minHeight: 0, overflow: 'hidden' }}>
      <div role="tablist" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', borderBottom: '1px solid var(--line)', flex: 'none' }}>
        {tabs.map(([k, label]) => (
          <button key={k} role="tab" aria-selected={pestana === k} onClick={() => onPestana(k)} style={{
            height: 56, border: 'none', background: 'var(--surface)', fontSize: 17, fontWeight: 700, cursor: 'pointer',
            color: pestana === k ? 'var(--ink)' : 'var(--muted)', boxShadow: pestana === k ? 'inset 0 -3px 0 var(--brand-texto)' : 'none',
          }}>{label}</button>
        ))}
      </div>

      {pestana === 'mesa' && !d && (
        <div style={{ flex: 1, display: 'grid', placeItems: 'center', padding: 32, textAlign: 'center', fontSize: 17, color: 'var(--muted)', lineHeight: 1.45 }}>
          Toca una mesa para ver su pedido y acciones.
        </div>
      )}

      {pestana === 'mesa' && d && st && <>
        <div style={{ flex: 1, minHeight: 0, overflowY: 'auto', padding: 20, display: 'flex', flexDirection: 'column', gap: 18 }}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12 }}>
              <h2 style={{ margin: 0, fontSize: 30, fontWeight: 700, lineHeight: 1 }}>{d.titulo}</h2>
              <span style={{ ...chip(st.bg, st.fg), padding: '6px 12px', fontSize: 15, border: `2px ${st.borde} ${st.bd}` }}>{st.label}</span>
            </div>
            <div style={{ fontSize: 15, color: 'var(--muted)' }}>{d.zona}</div>
          </div>

          <dl style={{ margin: 0, display: 'grid', gridTemplateColumns: 'auto 1fr', gap: '10px 16px', fontSize: 16 }}>
            {d.info.map(i => <FilaInfo key={i.k} k={i.k} v={i.v} />)}
          </dl>

          {d.pedirPersonas && (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
              <div id="personas-lbl" style={{ fontSize: 16, fontWeight: 700 }}>¿Cuántas personas?</div>
              <div role="group" aria-labelledby="personas-lbl" style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                <button onClick={() => onPersonas(Math.max(1, personas - 1))} aria-label="Menos personas" style={cuadro}>−</button>
                <div aria-live="polite" style={{ flex: 1, textAlign: 'center', fontSize: 36, fontWeight: 700 }}>{personas}</div>
                <button onClick={() => onPersonas(Math.min(30, personas + 1))} aria-label="Más personas" style={cuadro}>+</button>
              </div>
            </div>
          )}

          {d.nota && <div style={{ padding: '14px 16px', borderRadius: 12, background: 'var(--bg)', fontSize: 16, lineHeight: 1.4 }}>{d.nota}</div>}

          {d.items === null && <div style={{ color: 'var(--muted)' }}>Cargando pedido…</div>}
          {d.items && d.items.length > 0 && (
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <div style={{ fontSize: 16, fontWeight: 700, paddingBottom: 8, borderBottom: '1px solid var(--line)' }}>Pedido</div>
              {d.items.map((i: any) => {
                const e = ESTADO_ITEM[i.estado] || ESTADO_ITEM.pendiente;
                return (
                  <div key={i.id} style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '12px 0', borderBottom: '1px solid var(--line-2)' }}>
                    <span style={{ fontWeight: 700, width: 28 }}>{i.cantidad}×</span>
                    <div style={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column', gap: 2 }}>
                      <span style={{ fontSize: 16, fontWeight: 700 }}>{i.producto}</span>
                      <span style={{ fontSize: 14, color: 'var(--muted)' }}>{i.notas || TIEMPOS[i.tiempo] || ''}</span>
                    </div>
                    <span style={chip(e.bg, e.fg)}>{e.label}</span>
                  </div>
                );
              })}
              <div style={{ display: 'flex', justifyContent: 'space-between', paddingTop: 14, fontSize: 20, fontWeight: 700 }}><span>Total</span><span>{money(d.total)}</span></div>
            </div>
          )}

          {d.enlaces.length > 0 && (
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 16 }}>
              {d.enlaces.map(a => (
                <button key={a.label} onClick={a.onClick} style={{ background: 'none', border: 'none', padding: 0, fontSize: 15, fontWeight: 700, color: 'var(--muted)', textDecoration: 'underline', cursor: 'pointer' }}>{a.label}</button>
              ))}
            </div>
          )}
        </div>
        {d.acciones.length > 0 && (
          <div style={{ flex: 'none', padding: '16px 20px 20px', borderTop: '1px solid var(--line)', display: 'flex', flexDirection: 'column', gap: 10 }}>
            {d.acciones.map(a => (
              <button key={a.label} onClick={a.onClick} style={a.primaria ? btnPrimario : { ...btnSecundario, height: 56, fontSize: 18, borderRadius: 12 }}>{a.label}</button>
            ))}
          </div>
        )}
      </>}

      {pestana === 'llevar' && (
        <div style={{ flex: 1, minHeight: 0, overflowY: 'auto', padding: 20, display: 'flex', flexDirection: 'column', gap: 12 }}>
          <button onClick={onNuevoLlevar} style={btnPrimario}>Nuevo para llevar</button>
          {!llevar.length && <div style={{ color: 'var(--muted)', fontSize: 16, textAlign: 'center', padding: 16 }}>No hay pedidos para llevar abiertos.</div>}
          {llevar.map(o => {
            const e = o.estado === 'lista' ? ESTADO_ITEM.listo : o.cobro_tipo === 'inmediato' ? { label: 'Prepago', bg: 'var(--cobrar-bg)', fg: 'var(--cobrar-fg)' } : { label: 'En cocina', bg: 'var(--well)', fg: 'var(--ink-2)' };
            return (
              <button key={o.comanda_id} onClick={() => onLlevar(o)} style={{
                textAlign: 'left', padding: '14px 16px', borderRadius: 12, border: '1px solid var(--line)', background: 'var(--surface)',
                display: 'flex', flexDirection: 'column', gap: 6, cursor: 'pointer', color: 'var(--ink)',
              }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 8, width: '100%' }}>
                  <span style={{ fontSize: 18, fontWeight: 700 }}>{o.cliente_nombre || 'Para llevar'}</span>
                  <span style={chip(e.bg, e.fg)}>{e.label}</span>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', fontSize: 15 }}>
                  <span style={{ color: 'var(--muted)' }}>{o.mesero} · {minutosDesde(o.created_at)} min</span>
                  <span style={{ fontWeight: 700, fontSize: 17 }}>{money(parseFloat(o.total))}</span>
                </div>
              </button>
            );
          })}
        </div>
      )}
    </aside>
  );
}

function FilaInfo({ k, v }: { k: string; v: string }) {
  return <>
    <dt style={{ color: 'var(--muted)' }}>{k}</dt>
    <dd style={{ margin: 0, fontWeight: 700, textAlign: 'right' }}>{v}</dd>
  </>;
}
